import { BaseRequest } from "./base.request";


export class AuthRequest extends BaseRequest {
  token: string;

  constructor(token: string = '') {
    super();
    this.token = token;
  }
}
